import { render, staticRenderFns } from "./MealPhotos.vue?vue&type=template&id=15e8a467&scoped=true&"
import script from "./MealPhotos.vue?vue&type=script&lang=js&"
export * from "./MealPhotos.vue?vue&type=script&lang=js&"
import style0 from "./MealPhotos.vue?vue&type=style&index=0&id=15e8a467&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8a467",
  null
  
)

export default component.exports